import peopleRouteStore from '../store/Store';
import setCurrentPeopleRoute from '../actions/setCurrentPeopleRoute';
import { mutator } from 'satcheljs';

export default mutator(setCurrentPeopleRoute, nextRoute => {
    peopleRouteStore.location = nextRoute.location;
    peopleRouteStore.folderId = nextRoute.folderId;
    peopleRouteStore.subLocation = nextRoute.subRoute;
    peopleRouteStore.subLocationOption = nextRoute.subRouteOption;
});
